import { SignRequest } from '@bitte-ai/types';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { signRequestId } from '../lib/evm';

export type TransactionStatus = 'pending' | 'success' | 'error' | 'cancelled';

export interface TransactionState {
  txHash?: string;
  status: TransactionStatus;
  error?: string;
  messageId: string;
  timestamp: number;
  signature?: string;
}

// Create a family of atoms, one for each transaction ID
export const transactionAtomFamily = atomFamily((_txId: string) => {
  // TODO: txId is not even used... why is it here?
  return atom<TransactionState | null>(null);
});

// Helper functions
export const createTxId = (
  request: SignRequest,
  timestamp = Date.now(),
): string => {
  const hashToSign = signRequestId(request);
  return `evm-tx-${request.method}-${request.chainId}-${hashToSign}-${timestamp}`;
};

// For tracking all active transaction IDs
export const activeTransactionIdsAtom = atom<string[]>([]);

// For tracking signing states by messageId
// The _messageId parameter is prefixed with underscore because we don't use it in the atom creation function itself - Jotai uses it as the lookup key to manage separate atom instances.
export const signingStateAtomFamily = atomFamily((_messageId: string) =>
  atom<boolean>(false),
);

// Helper functions to initialize a transaction
export const initTransaction = (
  txId: string,
  messageId: string,
): {
  txId: string;
  txAtom: ReturnType<typeof transactionAtomFamily>;
  initialState: TransactionState;
} => {
  const txAtom = transactionAtomFamily(txId);

  return {
    txId,
    txAtom,
    initialState: {
      status: 'pending' as TransactionStatus,
      messageId,
      timestamp: Date.now(),
    },
  };
};
